<template>
  <div data-grm-comp="RoomTestbankExamSubmitUserTable">
    <div class="flex-col hidden lg:flex">
      <table>
        <colgroup>
          <col width="2%">
          <col width="10%">
          <col v-if="testbankExamHistory.examType === 'QUIZ'" width="3%">
          <col width="10%">
        </colgroup>
        <thead class="h-8 bg-gray-200">
        <tr>
          <th>{{ $t("common.number") }}</th>
          <th>{{ $t("common.name") }}</th>
          <th v-if="testbankExamHistory.examType === 'QUIZ'">{{ $t("testBank.score") }}</th>
          <th>{{ $t("testBank.partiTime") }}</th>
        </tr>
        </thead>
      </table>
      <div class="max-h-full overflow-y-auto scrollbar-hide">
        <table>
          <colgroup>
            <col width="2%">
            <col width="10%">
            <col v-if="testbankExamHistory.examType === 'QUIZ'" width="3%">
            <col width="10%">
          </colgroup>
          <tbody>
          <template>
            <tr v-for="(user, i) in testbankExamHistory.roomExamUserList"
                :key="user.userId"
                class="cursor-pointer transition hover:bg-gray-100"
                @click="onSelectUser(user)"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ user.username }}</td>
              <td v-if="testbankExamHistory.examType === 'QUIZ'">{{ user.examScore }}{{ $t('exam.question.point') }}</td>
              <td>{{ user.beginDate }} ~ {{ user.endDate }}</td>
            </tr>
            <tr v-if="!testbankExamHistory.roomExamUserList?.length">
              <td colspan="5" class="text-center">{{ $t("testBank.noSubmit") }}</td>
            </tr>
          </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="flex flex-col gap-2 lg:hidden">
      <div v-for="(user, i) in testbankExamHistory.roomExamUserList"
           :key="user.userId"
           class="p-2 rounded bg-gray-100"
      >
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("common.number") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ i + 1 }}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("common.name") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ user.username }}</div>
        </div>
        <div v-if="testbankExamHistory.examType === 'QUIZ'" class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("testBank.score") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ user.examScore }}{{ $t('exam.question.point') }}</div>
        </div>
        <div class="flex">
          <div class="w-28 py-2 px-3 text-sm">{{ $t("testBank.partiTime") }}</div>
          <div class="min-w-0 flex-1 py-2 px-3 text-sm">{{ user.beginDate }} ~ {{ user.endDate }}</div>
        </div>
        <div class="py-2 px-3 flex justify-center">
          <div class="w-full flex gap-x-1">
            <GrmBtn class="flex-1" @click="onSelectUser(user)">{{ $t("setting.disclosure.password.see") }}</GrmBtn>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

import GrmBtn from "@/components/Common/button/GrmBtn.vue";

export default {
  name: 'RoomTestbankExamSubmitUserTable',
  components: {
    GrmBtn,
  },
  computed: {
    ...mapState('testbank', [
      'testbankExamHistory',
    ]),
  },
  created() {
    this.getTestbankExamHistory();
  },
  methods: {
    ...mapMutations('testbank', [
      'SET_VIEW',
      'SET_TESTBANK_EXAM_HISTORY_USER',
    ]),
    ...mapActions('testbank', [
      'getTestbankExamHistory',
    ]),

    onSelectUser(user) {
      this.SET_TESTBANK_EXAM_HISTORY_USER(user);
      this.SET_VIEW('history__exam__user');
    },
  }
}
</script>

<style lang="postcss" scoped>
  table { @apply w-full text-sm text-center table-fixed }
  tr { @apply h-10 border-b border-gray-100 }
  th { @apply px-3 text-xs }
  td { @apply px-3 text-xs truncate }
</style>